// app/src/pages/Private.jsx
import React from 'react';

export default function Private() {
  return (
    <div className="p-6 text-center text-2xl text-gray-800">
      Welcome to the Private Page
    </div>
  );
}
